import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { VerifyApostille } from './pages/VerifyApostille';
import { Missions } from './pages/missions/Missions';
import { ProtocolDesk } from './pages/protocol/ProtocolDesk';
import { ConsularCases } from './pages/consular/ConsularCases';
import { OverseasCivilEvents } from './pages/civil/OverseasCivilEvents';
import { ApostilleRequests } from './pages/apostille/ApostilleRequests';
import { DiasporaRegistry } from './pages/diaspora/DiasporaRegistry';
import { Shell, type NavHeader, type NavItem } from './ui/Shell';

const NAV: Array<NavItem | NavHeader> = [
  { header: 'Reference' },
  { to: '/missions', label: 'Mission directory', icon: '🌐' },

  { header: 'Protocol & Diplomacy' },
  { to: '/protocol', label: 'Protocol desk', icon: '⚖' },

  { header: 'Consular Services' },
  { to: '/consular-cases', label: 'Consular cases', icon: '📄' },
  { to: '/civil-events', label: 'Overseas civil events', icon: '📜' },

  { header: 'Legalisation' },
  { to: '/apostille', label: 'Apostille pipeline', icon: '✓' },
  { to: '/verify', label: 'Public verify page', icon: '🔎' },

  { header: 'Diaspora' },
  { to: '/diaspora-registry', label: 'Diaspora registry', icon: '🌍' },
];

const ROLE_TO_LANDING: Record<string, string> = {
  PROTOCOL_OFFICER: '/protocol',
  MISSION_HEAD: '/consular-cases',
  CONSULAR_OFFICER: '/consular-cases',
  APOSTILLE_AUTHORITY: '/apostille',
};

export function App() {
  const { persona } = useAuth();

  // /verify is genuinely public — no sign-in required (spec: "the genuinely
  // public multilingual verify page — surface it prominently, no auth
  // needed") — declared here, outside the persona gate below, so it
  // resolves regardless of sign-in state.
  return (
    <Routes>
      <Route path="/verify" element={<VerifyApostille />} />
      {!persona ? (
        <>
          <Route path="/signin/complete" element={<SignInComplete />} />
          <Route path="*" element={<Login />} />
        </>
      ) : (
        <>
          <Route element={<Shell title={persona.org} items={NAV} />}>
            <Route index element={<Navigate to={persona.roles.map((r) => ROLE_TO_LANDING[r]).find(Boolean) ?? '/missions'} replace />} />
            <Route path="missions" element={<Missions />} />
            <Route path="protocol" element={<ProtocolDesk />} />
            <Route path="consular-cases" element={<ConsularCases />} />
            <Route path="civil-events" element={<OverseasCivilEvents />} />
            <Route path="apostille" element={<ApostilleRequests />} />
            <Route path="diaspora-registry" element={<DiasporaRegistry />} />
          </Route>
          <Route path="*" element={<Navigate to={persona.roles.map((r) => ROLE_TO_LANDING[r]).find(Boolean) ?? '/missions'} replace />} />
        </>
      )}
    </Routes>
  );
}
